module.exports = __webpack_public_path__ + "static/img/A6108.a0b97e0e.png";